import type { Config } from './types/Config'

// Global: Declare -------------------------------
declare global {
  var $config: Config
}

// Global: Initial -------------------------------
globalThis.$config = <Config>{}

// Script: prevent drag --------------------------
window.ondragstart = (event: DragEvent) => {
  return false
}

// Script: prevent context menu ------------------
window.oncontextmenu = (event: MouseEvent) => {
  event.preventDefault()
  event.stopPropagation()
  return false
}

// -----------------------------------------------
